export enum LoadingState {
  None,
  Pending,
  Complete,
  Error,
}
